<div class="front-wrap" (window:resize)="fn_OnResize($event)">
  <div class="front-store-content">
    <div class="container-fluid search-results" infiniteScroll [infiniteScrollDistance]="6"
      [infiniteScrollThrottle]="100" [infiniteScrollDisabled]="scrollDisabled || isFullListDisplayed"
      (scrolled)="fn_GetOrderListing(false)">
      <div class="container order-container">
        <div class="row">
          <div class="col-sm-8">
            <div class="dash-head">
              <h2>Orders</h2>
            </div>
          </div>
          <div class="col-sm-4">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Order Upload Actions
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-sm-12  odr-action-wrap">
                  <ng-container *ngIf="userRole == 'SuperAdmin' || userRole == 'CustomerService'">
                    <label class="dpst-lbl">Impress Invoice Deposit: </label>
                    <button mat-icon-button matTooltip="Upload Impress orders to create deposit" class="btn btn-upload"
                      (click)="fn_ImpressInvoiceDialog()">
                      <mat-icon aria-hidden="false" aria-label="file upload">file_upload</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 odr-action-wrap">
                  <ng-container *ngIf="userRole == 'SuperAdmin' || userRole == 'CustomerService'">
                    <label class="dpst-lbl">OpenAPI Invoice Deposit: </label>
                    <div>
                      <button mat-icon-button matTooltip="Upload OpenAPI orders invoice to Impress"
                        class="btn btn-upload" (click)="fn_OpenAPIUploadInvoiceDialog()">
                        <mat-icon aria-hidden="false" aria-label="file upload">file_upload</mat-icon>
                      </button>
                      &nbsp;
                      <a mat-icon-button matTooltip="Download OpenAPI orders invoice"
                        (click)="fn_OpenAPIInvoiceDialog()" class="btn btn-upload">
                        <mat-icon aria-hidden="false" aria-label="file upload">file_download</mat-icon>
                      </a>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 odr-action-wrap">
                  <ng-container *ngIf="userRole == 'SuperAdmin' || userRole == 'CustomerService'">
                    <label class="dpst-lbl">Mark Shipped in Impress Only: </label>
                    <div>
                      <button mat-icon-button matTooltip="Upload orders" class="btn btn-upload"
                        (click)="fn_MarkShippedImpressDialog()">
                        <mat-icon aria-hidden="false" aria-label="file upload">file_upload</mat-icon>
                      </button>
                      <button mat-icon-button matTooltip="Recent uploads" class="btn btn-upload"
                        (click)="fn_openRecentUploads()">
                        <mat-icon aria-hidden="false" aria-label="recent uploads">history</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </div>

        <form [formGroup]="orderFilterForm" class="frm-ordr-lst">

          <mat-form-field class="example-full-width" style="width: 130px;">
            <mat-label style="font-size: 11px;">By Order#, SB Order#</mat-label>
            <input matInput type="text" formControlName="orderNumber" ng-model-options="{debounce: 10000}"
              (change)="fn_GetOrderListing(true)">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label style="font-size: 11px;">By Name, Product, Address</mat-label>
            <input matInput type="text" formControlName="orderedUserName" ng-model-options="{debounce: 10000}"
              (change)="fn_GetOrderListing(true)">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label style="font-size: 11px;">By Email</mat-label>
            <input matInput type="text" formControlName="orderUserEmail" ng-model-options="{debounce: 10000}"
              (change)="fn_GetOrderListing(true)">
          </mat-form-field>
          <mat-form-field>
            <mat-label style="font-size: 12px;">Order Status</mat-label>
            <mat-select formControlName="selectedOrderStatus" (selectionChange)="fn_GetOrderListing(true)">
              <mat-option value="0">All</mat-option>
              <mat-option value="1">Ordered</mat-option>
              <mat-option value="2">Confirmed</mat-option>
              <mat-option value="3">Processing</mat-option>
              <mat-option value="5">Shipped</mat-option>
              <mat-option value="6">Delivered</mat-option>
              <mat-option value="4">Cancelled</mat-option>
              <mat-option value="7">Produced</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-checkbox class="mt-chck-bx-ordsk" style="padding: 0px 15px; font-size: 13px;"
            formControlName="isOrderDesk" (change)="fn_GetOrderListing(true)">
            Order Desk
          </mat-checkbox>

          <button type="button" class="btn btn-danger" style="font-size: 12px; padding: 5px;"
            (click)="fn_clearFilter()">
            Clear Filter
          </button>

        </form>


        <div class="sp-admin-list-tbl pro-tble-outer cust cmsn-bx-ut table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th width="150">Order#</th>
                <!--<th>Store</th>-->
                <th width="300">Product</th>
                <th width="130">Cost</th>
                <th width="180"> Status</th>
                <th width="200">Address</th>
                <th>Origin</th>
              </tr>
            </thead>
            <tbody *ngFor="let order of orderList">
              <tr *ngFor="let item of order.OrderItems;let first = first">
                <td [attr.rowspan]="order.OrderItems.length" [hidden]="!first">
                  <div class="col-md-12">
                    <div class="ord-dt-no"
                      *ngIf="order.OrderNo != '' && (order.TempOrderNo == '' || order.TempOrderNo == undefined)">
                      <span title="View Order Status" class="mat-btn mat-track" style="cursor: pointer;"
                        (click)="fn_RedirectToOrderDetail(order.OrderNo)">
                        <strong>{{order.OrderNo}}</strong>
                        <strong>{{order.TempOrderNo}}</strong>
                      </span>
                    </div>
                    <div style="float: left;" *ngIf="order.OldOrderNo && order.OldOrderNo != order.OrderNo">
                      <span class="mat-btn mat-track"
                        style="cursor: pointer;font-size: 10px;background: none;border-radius: 5px;text-transform: uppercase;border: 1px solid #5bbab4;">
                        <strong>{{order.OldOrderNo}}</strong>
                      </span>
                    </div>
                    <!-- <div *ngIf="userRole === 'SuperAdmin' ||userRole === 'CustomerService'">
                      <span class="badge badge-cart" (click)="fn_ShowImpressBox(order.OrderId)" title="Add Impress Order#" *ngIf="order.OrderNo.includes('SB') && (order.TempOrderNo == '' || order.TempOrderNo == undefined)" style="cursor: pointer; width: 29px; margin-top: -11px; border-radius: 25% !important;">Edit</span>
                      <input type="text" [(ngModel)]="order.OrderNo" style="width:85px !important; height:30px !important; float: left;" class="form-control" *ngIf="order.ShowEditForm && (order.OrderNo.includes('SB') || order.TempOrderNo.includes('SB'))" />
                      <i class="fa fa-save" aria-hidden="true" (click)="fn_SaveImpressForm(order.OrderId)" style="color: green; font-size: 15px; margin-left: 10px; cursor: pointer;" *ngIf="order.ShowEditForm && (order.OrderNo.includes('SB') || order.TempOrderNo.includes('SB'))" title="Save"></i>
                      <i class="fa fa-times-circle" (click)="fn_CloseImpressForm(order.OrderId)" aria-hidden="true" style="color: red; font-size: 15px; margin-left: 10px; cursor: pointer;" *ngIf="order.ShowEditForm && (order.OrderNo.includes('SB') || order.TempOrderNo.includes('SB'))" title="Cancel"></i>
                    </div> -->
                    <br />
                    <br />
                    <div *ngIf="order.IsReplacementOrder" class="rep-ord-tag-div">
                      <strong class="text-danger rep-ord-tag">*Replacement order For {{order.ParentOrderNo}}</strong>
                    </div>
                    <br />
                    <small *ngIf="order.TransactionDetail != null" class="text-info"
                      (click)="handleTransactionDetail(order.TransactionDetail, order.OrderNo)">
                      View Transaction details
                    </small>
                  </div>
                </td>
                <!--<td class="example-full-width" [attr.rowspan]="order.OrderItems.length" [hidden]="!first">
                  <a title="Store Link" href="{{order.StoreURL}}" target="_blank">{{order.StoreName}}</a>
                </td>-->
                <td>
                  <div *ngIf="first" class="order-date">
                    Ordered On <i>{{getDate(order.OrderDate,false) | date : 'fullDate'}}</i>
                  </div>

                  <div *ngIf="!item.IsWareHouseProduct" class="mat-sz-avt">
                    <img style="height:80px;" [src]="item.ImageName" alt="" />
                  </div>
                  <div *ngIf="item.IsWareHouseProduct" class="mat-sz-avt">
                    <img style="height:80px;" *ngIf="item.DesignId>0" src="{{item.PngRelativeUrlWithProduct}}" />
                    <img style="height:80px;" *ngIf="item.DesignId<0"
                      src="{{imgWareHouseBaseURL + item.PngRelativeUrlWithProduct}}" />
                  </div>
                  <div class="mat-sz-avt">
                    <strong title="View Product"
                      [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default', 'color':'#0645AD','text-transform': 'capitalize'}"
                      (click)="userRole === 'SuperAdmin' ||userRole === 'CustomerService' ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)">
                      {{item.DesignName}}&nbsp;<span style="font-size:10px"
                        class="text-info">({{item.CustomizeType}})</span><sup class="text-danger"
                        *ngIf="item.IsSampleOrder">&nbsp;* Sample Order</sup><sup class="text-danger"
                        *ngIf="item.IsWareHouseProduct">&nbsp; **Warehouse Product</sup>
                    </strong>
                    <br />
                    <small>
                      Color <strong>{{item.ColorName}}</strong>
                      <br />
                      Size <strong>{{item.SizeName}}</strong>
                      <br />
                      Price/Piece
                      <strong *ngIf="order.IsShopifyOrder && item.ShopifyUnitPrice > 0">{{item.ShopifyUnitPrice | currency:'USD':'symbol':'1.2-2'}}</strong>
                      <strong *ngIf="!(order.IsShopifyOrder && item.ShopifyUnitPrice > 0)">{{item.UnitPrice | currency:'USD':'symbol':'1.2-2'}}</strong><br />
                      Quantity <strong>{{ item.Quantity}}</strong><br />
                      <div *ngIf="item.IsCancelled">
                        <strong class="text-danger">Cancelled</strong>
                      </div>
                    </small>
                  </div>
                </td>
                <td class="example-full-width" [attr.rowspan]="order.OrderItems.length" [hidden]="!first"
                  style="vertical-align: top;">
                  <small>
                    <!-- Non SOP-hosted orders: existing layout -->
                    <ng-container *ngIf="!order._isSopHosted">
                      <!--Sub Total <strong class="float-right">{{item.UnitPrice  * item.Quantity | currency:'USD':'symbol':'1.2-2'}}</strong>-->
                      Sub Total
                      <strong class="float-right">{{order.SubTotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                      <br />
                      <ng-container *ngIf="order.Discount">
                        Discount <strong class="float-right">
                          {{order.Discount |currency:'USD':'symbol':'1.2-2' }}
                        </strong>
                        <br />
                      </ng-container>
                      Shipping <strong class="float-right">
                        {{order.ShippingCost |currency:'USD':'symbol':'1.2-2' }}
                      </strong>
                      <br />
                      <span>
                        Total <strong class="float-right">
                          {{order.TotalPrice | currency:'USD':'symbol':'1.2-2'}}
                        </strong>
                      </span>
                    </ng-container>

                    <!-- SOP-hosted orders: Sub Total / Shipping / Sales Tax / Amount Paid (no Total line) -->
                    <ng-container *ngIf="order._isSopHosted">
                      Sub Total
                      <strong class="float-right">{{order._subTotalWithProfit | currency:'USD':'symbol':'1.2-2'}}</strong>
                      <br />
                      Shipping <strong class="float-right">{{order.ShippingCost | currency:'USD':'symbol':'1.2-2'}}</strong>
                      <br />
                      <ng-container *ngIf="order._salesTaxAmount">
                        Sales Tax <strong class="float-right">{{order._salesTaxAmount | currency:'USD':'symbol':'1.2-2'}}</strong>
                        <br />
                      </ng-container>
                      Amount Paid <strong class="float-right">{{order._amountPaid | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </ng-container>

                    <!-- Shopify-reported order total (shown only for Shopify orders) -->
                    <ng-container *ngIf="order.IsShopifyOrder && order.ShopifyOrderTotal > 0">
                      <hr class="my-1" />
                      Shopify Order Total
                      <strong class="float-right">{{order.ShopifyOrderTotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </ng-container>

                    <!-- Shopify discounts (shown only for Shopify orders that have them) -->
                    <ng-container *ngIf="order.IsShopifyOrder && getShopifyDiscounts(order.ShopifyDiscounts).length > 0">
                      <br />
                      Shopify Discounts
                      <span class="float-right text-right">
                        <div *ngFor="let d of getShopifyDiscounts(order.ShopifyDiscounts)">{{ d }}</div>
                      </span>
                    </ng-container>
                  </small>
                </td>
                <td [attr.rowspan]="order.OrderItems.length" [hidden]="!first" style="vertical-align: top;">
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Ordered'" style="position:relative">
                    <i class="fa fa-home"></i> {{order.OrderStatus}} <br>
                    <mat-hint style="font-size: 11px;">
                      Your order has been ordered on {{getDate(order.OrderDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Confirmed'" style="position:relative">
                    <i class="fa fa-check-circle-o" aria-hidden="true"></i> {{order.OrderStatus}} <br>
                    <mat-hint style="font-size: 11px;">
                      Your order has been confirmed on {{getDate(order.ConfirmationDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Processing'" style="position:relative">
                    <i class="fa fa-truck"></i> {{order.OrderStatus}} <br>
                    <mat-hint style="font-size: 11px;">
                      Your order is under process on {{getDate(order.ProcessingDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Cancelled'" style="position:relative">
                    <i class="fa fa-times"></i> {{order.OrderStatus}} <br>
                    <mat-hint style="font-size: 11px;">
                      Your order has been cancelled on {{getDate(order.CancelledDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Dispatched'" style="position:relative">
                    <i class="fa fa-check-circle-o"></i> Shipped <br>
                    <mat-hint style="font-size: 11px;">
                      Your order has been Shipped on {{getDate(order.DispatchedDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Delivered'" style="position:relative">
                    <i class="fa fa-check-circle-o"></i> {{order.OrderStatus}} <br>
                    <mat-hint style="font-size: 11px;">
                      Your order has been dispatched on {{getDate(order.DeliveredDate,true)}}
                    </mat-hint>
                  </small>
                  <small class="mt-qt" *ngIf="order.OrderStatus === 'Produced'" style="position:relative">
                    <i class="fa fa-check-circle-o"></i> {{order.OrderStatus}} <br>
                    <!-- <mat-hint style="font-size: 11px;">
                      Your order has been Produced on
                    </mat-hint> -->
                  </small>
                  <br />
                  <br />
                  <small *ngIf="order.CancelOrderRequestStatus == 1" class="text-danger">
                    <b>Requested for Cancellation</b><br />
                    <ng-container *ngIf="!order.IsOrderDeskOrder">
                      <span *ngIf="order.IsRefunded">
                        <strong>Refund Status :</strong><span class="text-info">
                          &nbsp;
                          Refunded
                        </span><br />
                        <span style="color:black">
                          Your amount has been refunded on
                          {{getDate(order.RefundDate,true)}}
                        </span>
                      </span>
                      <br />
                      <span *ngIf="!order.IsRefunded">
                        <strong>Refund Status :</strong> <span class="text-danger">&nbsp;Pending...</span>
                      </span>
                    </ng-container>
                  </small>
                  <small *ngIf="order.CancelOrderRequestStatus == 2" class="text-success">
                    <b><i class="fa fa-check-circle-o"></i>&nbsp;Cancellation request Approved </b>
                  </small>
                  <small *ngIf="order.CancelOrderRequestStatus == 3" class="text-danger">
                    <b><i class="fa fa-times" aria-hidden="true"></i>&nbsp;Cancellation request Rejected </b>
                  </small>
                </td>
                <td [attr.rowspan]="order.OrderItems.length" [hidden]="!first" style="vertical-align: top;">
                  <small *ngIf="order.AddressModel">
                    {{order.AddressModel.Name}} <br />
                    {{order.AddressModel.AddressLine}} <br />
                    <ng-container *ngIf="order.AddressModel.AddressLine2">
                      {{order.AddressModel.AddressLine2}} <br />
                    </ng-container>
                    {{order.AddressModel.Country}} {{order.AddressModel.CountryCode}}, {{order.AddressModel.State}}
                    {{order.AddressModel.StateCode}} - {{order.AddressModel.ZipCode}} <br />
                    <span class="text-info">Contact No.: </span> {{
                    order.AddressModel.PhoneNumber | mask: '(000)
                    000-0000'
                    }}<br />
                    <span class="text-info">Email: </span> {{order.AddressModel.Email }}
                  </small>
                </td>
                <td [attr.rowspan]="order.OrderItems.length" [hidden]="!first">
                  <div *ngIf="userRole === 'SuperAdmin' || userRole === 'CustomerService'">
                    <small class="l-s-0-6 text-info" *ngIf="order.IsOrderDeskOrder; else non_od_content">
                      <img src="assets/img/orderdesk_black.png" width="18" />
                      Order Desk &nbsp;<span *ngIf="order.SourceOrderNumber">#{{order.SourceOrderNumber}}</span>
                    </small>
                    <ng-template #non_od_content>
                      <small class="l-s-0-6 text-info" *ngIf="order.IsShopifyOrder == true">
                        Shopify &nbsp;<span *ngIf="order.ShopifyOrderNo !=null">#{{order.ShopifyOrderNo}}</span>
                      </small>
                      <small class="l-s-0-6 text-info" *ngIf="order.IsShopifyOrder == false">
                        MerchLoop
                      </small>
                    </ng-template>
                  </div>

                  <br />

                  <button class="btn btn-danger" style="font-size: 12px; padding: 5px;color:#fff!important"
                    *ngIf="(userRole === 'SuperAdmin'|| userRole ==='CustomerService') && order.OrderStatusId < 4 && order.CancelOrderRequestStatus == 0"
                    (click)="RequestCancelOrder(order)">
                    Cancel
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <mat-card class="spg-mat-card mat-card-cmn" style="display: none;" [ngStyle]="{'display': isDisplay}">
          <mat-card-content>
            <div class="text-center">
              <span> No records available</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <app-lazy-loader></app-lazy-loader>
    </div>
  </div>
</div>



<ng-template #openAPIInvoiceDialog let-data>
  <button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 matDialogTitle>OpenAPI order invoice download</h2>

  <form [formGroup]="invoiceForm" (submit)="fn_DownloadInvoice()">
    <mat-dialog-content>
      <div class="rpot-bx">
        <div class="row">
          <div class="col-sm-6 st-spc-lt">
            <div class="row">
              <div class="col-lg-4">
                <label>Start Date</label>
              </div>
              <div class="col-lg-8">
                <mat-form-field>
                  <input matInput [matDatepicker]="startpicker" placeholder="mm/dd/yyyy"
                    (dateChange)="FromDateEvent('change', $event)" formControlName="FromDate">
                  <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                  <mat-datepicker #startpicker></mat-datepicker>
                  <mat-error
                    *ngIf="f.FromDate.invalid || (f.FromDate.touched && (f.FromDate.pristine || f.FromDate.dirty))">
                    <strong *ngIf="f.FromDate.errors && f.FromDate.errors.required">Required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-6 st-spc-rt">
            <div class="row">
              <div class="col-lg-4">
                <label>End Date</label>
              </div>
              <div class="col-lg-8">
                <mat-form-field>
                  <input matInput [matDatepicker]="endpicker" placeholder="mm/dd/yyyy"
                    (dateChange)="ToDateEvent('change', $event)" formControlName="ToDate">
                  <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                  <mat-datepicker #endpicker></mat-datepicker>
                  <mat-error *ngIf="f.ToDate.invalid || (f.ToDate.touched && (f.ToDate.pristine || f.ToDate.dirty))">
                    <strong *ngIf="f.ToDate.errors && f.ToDate.errors.required">Required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 st-spc-lt">
            <div class="row">
              <div class="col-lg-2">
                <label>Customer</label>
              </div>
              <div class="col-lg-6">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Choose customer</mat-label>
                  <input type="text" matInput formControlName="UserId" [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
                    <mat-option *ngFor="let option of openAPIUsers" [value]="option.UserId" [matTooltip]="option.Email">
                      {{option.Email}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="f.UserId.invalid || (f.UserId.touched && (f.UserId.pristine || f.UserId.dirty))">
                    <strong *ngIf="f.UserId.errors && f.UserId.errors.required">Required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="submit" class="mat-raised-button mat-primary" cdkFocusInitial
        matTooptip="Downloaded file will be in .xlsx format">
        Download invoice
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #openAPIUploadInvoiceDialog let-data>
  <button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 matDialogTitle>OpenAPI order invoice upload</h2>

  <form [formGroup]="invoiceUploadForm" (submit)="fn_UploadInvoiceFile()">
    <mat-dialog-content>
      <p>
        Deposit will be saved along with Cheque number in <b>Impress</b> for uploaded order numbers.
      </p>
      <mat-form-field>
        <input matInput placeholder="Cheque #" type="text" formControlName="chequeNo">
        <mat-error *ngIf="fu.chequeNo.invalid || (fu.chequeNo.touched && (fu.chequeNo.pristine || fu.chequeNo.dirty))">
          <strong *ngIf="fu.chequeNo.errors && fu.chequeNo.errors.required">Required</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Cheque amount" type="text" formControlName="chequeAmount">
        <mat-error
          *ngIf="fu.chequeAmount.invalid || (fu.chequeAmount.touched && (fu.chequeAmount.pristine || fu.chequeAmount.dirty))">
          <strong *ngIf="fu.chequeAmount.errors && fu.chequeAmount.errors.required">Required</strong>
          <strong *ngIf="fu.chequeAmount.errors && fu.chequeAmount.errors.required">
            Amount not in correct
            format
          </strong>
        </mat-error>
      </mat-form-field>
      <input id="myInput" #myInput type="file" (change)="fileChangeEvent($event)"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
      <div class="file-upload">
        <button type="button" matTooltip="Upload xlsx" mat-mini-fab color="primary" class="upload-btn"
          (click)="myInput.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
        {{invoiceFileName || "No file uploaded yet."}}
      </div>
      <br />
      <div>
        <mat-hint align="start">*Only .xlsx file type allowed</mat-hint>
      </div>
      <div>
        <mat-hint align="start">*Size should be less than 30 MB</mat-hint>
      </div>
      <div class="text-danger">
        {{invoiceFileErrorMessage}}
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button [disabled]="!invoiceFileUploaded || invoiceUploadForm.invalid" mat-raised-button type="submit">
        Submit
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>


<ng-template #impressInvoiceDialog let-data>
  <button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 matDialogTitle>Impress deposit</h2>

  <mat-dialog-content>
    <p>
      Deposit will be saved along with Cheque number in <b>Impress</b> for uploaded invoice numbers.
    </p>
    <input id="myImpressInvoiceInput" #myImpressInvoiceInput type="file"
      (change)="impressInvoicefileChangeEvent($event)"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
    <div class="file-upload">
      <button type="button" matTooltip="Upload xlsx" mat-mini-fab color="primary" class="upload-btn"
        (click)="myImpressInvoiceInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      {{impressInvoiceFileName || "No file uploaded yet."}}
    </div>
    <br />
    <div>
      <mat-hint align="start">*Only .xlsx file type allowed</mat-hint>
    </div>
    <div>
      <mat-hint align="start">*Size should be less than 30 MB</mat-hint>
    </div>
    <div class="text-danger">
      {{impressInvoiceFileErrorMessage}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="fn_ImpressInvoiceFile()" [disabled]="!impressInvoiceFileUploaded" mat-raised-button type="button">
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #markShippedImpressDialog let-data>
  <button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 matDialogTitle>Mark Shipped in Impress Only</h2>

  <mat-dialog-content>
    <p>
      Uploaded order numbers will be marked as shipped only in <b>Impress</b>.
    </p>
    <input id="markShippedImpressFileInput" #markShippedImpressFileInput type="file"
      (change)="markShippedImpressfileChangeEvent($event)"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
    <div class="file-upload">
      <button type="button" matTooltip="Upload xlsx" mat-mini-fab color="primary" class="upload-btn"
        (click)="markShippedImpressFileInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      {{markShippedImpressFileName || "No file uploaded yet."}}
    </div>
    <br />
    <div>
      <mat-hint align="start">*Only .xlsx file type allowed</mat-hint>
    </div>
    <div>
      <mat-hint align="start">*Size should be less than 30 MB</mat-hint>
    </div>
    <div class="text-danger">
      {{markShippedImpressFileErrorMessage}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="fn_markShippedImpressFile()" [disabled]="!markShippedImpressFileUploaded" mat-raised-button
      type="button">
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>